import { useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

export type UserType = 'notLogged' | 'guest' | 'logged';

export const useUserType = (): UserType => {
    const auth = useReactiveVar(authVar);

    if (auth.isGuest && auth.isLoggedIn) {
        return 'guest';
    }

    if (auth.isLoggedIn) {
        return 'logged';
    }

    return 'notLogged';
};
